import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private openModalCount = 0;

  incrementOpenModalCount() {
    this.openModalCount++;
  }

  decrementOpenModalCount() {
    this.openModalCount--;
  }

  getOpenModalCount() {
    return this.openModalCount;
  }
}
